import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const AnalyticsDashboard = lazy(() => import(`Pages/Screens/Office/Dashboards/Analytics`));

const DashboardsRoutes: RouteObject[]= [
    {
      path: 'dashboard',
      children: [
        {
          path: 'analytics',
          element: <LoadComponent component={AnalyticsDashboard} />,
        },
      ],
    },
]

export default DashboardsRoutes;